import { combineReducers } from '@reduxjs/toolkit';
import { baseApi } from '@consolidocs-ui/data-access';
import { AIServiceApi } from '@consolidocs-ui/data-access/AIServiceApi';
import uploadReducer from './slices/uploadSlice';
import { generalConfigurationReducer } from '@consolidocs-ui/hooks/generalConfigurationSlice';
import { toastReducer, notificationReducer } from '@consolidocs-ui/utils';
import filesMapReducer from './slices/filesMapSlice';
import citationReducer from './slices/citationSlice';

// Registering `baseApi` says what is actually meant. Previously this
// registered UserApi.reducer, which only worked because UserApi happened to be
// the module that injected into the shared instance.
const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [AIServiceApi.reducerPath]: AIServiceApi.reducer,
  toast: toastReducer,
  notifications: notificationReducer,
  upload: uploadReducer,
  generalConfiguration: generalConfigurationReducer,
  filesMap: filesMapReducer,
  citation: citationReducer,
});

export const middleware = [baseApi.middleware, AIServiceApi.middleware];

export default rootReducer;
